function Title({ currentUser }) {
  return (
    <div className='ball-save-title '>
      <div className='ball-save-title login-main-title'>Ball Save</div>
    </div>
  );
}

export default Title;
